<template>
  <div class="toggle-wrapper">
    <label class="toggle">
      <input
        type="checkbox"
        :checked="mode === 'dark' ? 'checked' : false"
        @change="$emit('toggle')"
      />
      <span class="toggler round"></span>
    </label>
  </div>
</template>

<script>
export default {
  props: ["mode"]
};
</script>

<style lang="scss">
@import "@/assets/css/base.scss";
.toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
  margin: 0;
}
.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggler {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #2c3e50;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.toggler:before {
  position: absolute;
  font-family: "Font Awesome 5 Free";
  content: "\f185";
  color: #e6e92e;
  font-weight: 900;
  vertical-align: middle;
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  @media all and (min-width: 1020px) {
    bottom: 5px;
  }
}
input:checked + .toggler {
  background: $first-color;
}
input:focus + toggler {
  box-shadow: 0 0 2px #2196f3;
}
input:checked + .toggler:before {
  transform: translateX(24px);
  font-family: "Font Awesome 5 Free";
  content: "\f186";
  color: #ffffff;
  font-weight: 900;
}
.toggler.round {
  border-radius: 34px;
}
.toggler.round:before {
  border-radius: 50%;
}
</style>
